import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { store } from "./app/store";
import "./index.css";
import App from "./app/App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { getCookieStateAnalytics } from "./features/app/UserRelatedSlice";

ReactGA.initialize("G-VBQEP6C6NP");

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

const RootComponent = () => {
  const analytics = useSelector(getCookieStateAnalytics);
  useEffect(() => {
    if (analytics) {
      reportWebVitals(SendAnalytics);
    }
  }, [analytics]);

  return <App />;
};

const container = document.getElementById("root") as HTMLElement;

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <RootComponent />
    </Provider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}


// import React, { useEffect, useState } from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './app/App';
// import reportWebVitals from './reportWebVitals';
// import { GlobalContainer } from './context/globalContext';
// import ReactGA from "react-ga4";

// ReactGA.initialize("G-VBQEP6C6NP");

// const SendAnalytics = () => {
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//   });
// };


// const RootComponent = () => {
//   const [analytics, setAnalytics] = useState(() => {
//     const item = localStorage.getItem("cookieAnalytics");
//     return item ? +item : 0;
//   });
//   useEffect(() => {
//     if (analytics) {
//       console.log("in analytics");
//       reportWebVitals(SendAnalytics);
//     }
//   }, [analytics]);

//   return (
//     <React.StrictMode>
//       <GlobalContainer setAnalytics={setAnalytics} />
//     </React.StrictMode>
//   );
// };

// const container = document.getElementById('root');
// if (container) {
//   const root = ReactDOM.createRoot(container);
//   root.render(<RootComponent />);
// } else {
//   console.error('Failed to find the root element');
// }